import {
  SoopLayerWrapper,
  SoopLayerHeader,
  SoopLayerContent,
  SoopButtonCommon,
} from '@soop-ui/soop-ui';
import styles from './InfoLayer.module.scss';
import ProfileMessage from '../../ProfileMessage';
import StreamerInfo from './Streamer';
import StreamerInfoContent from '@/components/channel/common/StreamerInfoContent';
import {useStationData, useStationUser} from '@/stores/channel/station';
import {useNavigate} from 'react-router-dom';
import {useRef} from 'react';
import {useOutsideClick} from '@/components/main/common/hooks/useOutsideClick';
import {ChannelT} from '@/utils/i18n/channel';

const ChannelInfoLayer = ({layerOpen}) => {
  const {station} = useStationData();
  const {userId: streamerId} = station.detail || {};
  const {userPermissions} = useStationUser();
  const {isOwner} = userPermissions || {};
  const {setIsInfoLayerOpen} = layerOpen;
  const navigate = useNavigate();
  const infoLayerRef = useRef(null);

  useOutsideClick(infoLayerRef, () => {
    setIsInfoLayerOpen(false);
  });
  <ChannelInfoLayer layerOpen={{setIsInfoLayerOpen}} />;
  return (
    <>
      <div ref={infoLayerRef}>
        <SoopLayerWrapper
          onClose={() => setIsInfoLayerOpen((prev) => !prev)}
          size='md'
          className={styles.LayerInfo}>
          <SoopLayerHeader>{ChannelT('스트리머 정보')}</SoopLayerHeader>
          <SoopLayerContent>
            <div className={styles.profileInfo}>
              <StreamerInfo />
              <div className={styles.streamerMsg}>
                <ProfileMessage className={styles.msg} />

                {/* 프로필 메세지 수정 버튼 : 본인 방송국인경우 노출 */}
                {isOwner && (
                  <div className={styles.messageEditButton}>
                    <SoopButtonCommon
                      onClick={() =>
                        navigate(`/station/${streamerId}/setting/basic`)
                      }
                      size={20}
                      variant='linePrimary'>
                      {ChannelT('수정')}
                    </SoopButtonCommon>
                  </div>
                )}
              </div>
            </div>

            {layerOpen && <StreamerInfoContent />}
          </SoopLayerContent>
        </SoopLayerWrapper>
      </div>
    </>
  );
};

export default ChannelInfoLayer;
